<template>
  <div v-if="hasPages" class="pagination section">
    <b-button
      :class="[
        'pagination__control',
        { 'pagination__control--disabled': !hasPrev }
      ]"
      icon-left="chevron-left"
      type="is-info"
      @click="getPage('prev')"
    >
    </b-button>
    <span class="pagination__label"> Page {{ currentPage }} </span>
    <b-button
      :class="[
        'pagination__control',
        { 'pagination__control--disabled': !hasNext }
      ]"
      icon-right="chevron-right"
      type="is-info"
      @click="getPage('next')"
    >
    </b-button>
  </div>
</template>

<script>
export default {
  props: {
    resourceState: {
      type: String,
      required: false
    }
  },
  computed: {
    state() {
      return this.$store.state[this.resourceState];
    },
    currentPage() {
      return this.state.currentPage;
    },
    hasNext() {
      return this.$store.getters[`${this.resourceState}/hasNext`];
    },
    hasPages() {
      return this.currentPage !== 1 || this.hasNext;
    },
    hasPrev() {
      return this.$store.getters[`${this.resourceState}/hasPrev`];
    }
  },
  methods: {
    getPage(type) {
      this.$store.dispatch(`${this.resourceState}/get`, type);
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;

  &__control {
    margin: 0 0.5rem;

    &--disabled {
      pointer-events: none;
      opacity: 0.5;
    }
  }

  &__label {
    margin: 0 0.5rem;
  }
}
</style>
